import { BaseEntity } from './base.entity';

export class Room extends BaseEntity {
  id: string;
  user_id: string;
  project_id: string;
  name: string;
  description: string | null;
  last_message_at: Date | null;
  created_at: Date;
  updated_at: Date;

  constructor(data: {
    id: string;
    user_id: string;
    project_id: string;
    name: string;
    description: string | null;
    last_message_at: Date | null;
    created_at: Date;
    updated_at: Date;
  }) {
    super();
    this.id = data.id;
    this.user_id = data.user_id;
    this.project_id = data.project_id;
    this.name = data.name;
    this.description = data.description;
    this.last_message_at = data.last_message_at;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.setOriginalData(this.toData());
  }

  /**
   * Update room information
   */
  updateInfo(name: string, description: string | null): void {
    this.name = name;
    this.description = description;
    this.updated_at = new Date();
    this.markAsDirty();
  }

  /**
   * Update last message timestamp
   */
  updateLastMessageTime(): void {
    this.last_message_at = new Date();
    this.updated_at = new Date();
    this.markAsDirty();
  }

  /**
   * Convert to plain data object
   */
  toData(): any {
    return {
      id: this.id,
      user_id: this.user_id,
      project_id: this.project_id,
      name: this.name,
      description: this.description,
      last_message_at: this.last_message_at,
      created_at: this.created_at,
      updated_at: this.updated_at
    };
  }

  /**
   * Create Room instance from database row
   */
  static fromData(data: any): Room {
    return new Room({
      id: data.id,
      user_id: data.user_id,
      project_id: data.project_id,
      name: data.name,
      description: data.description,
      last_message_at: data.last_message_at ? new Date(data.last_message_at) : null,
      created_at: new Date(data.created_at),
      updated_at: new Date(data.updated_at)
    });
  }
}

export interface RoomInsert {
  user_id: string;
  project_id: string;
  name: string;
  description?: string | null;
}

export interface RoomUpdate {
  name?: string;
  description?: string | null;
  last_message_at?: Date | null;
}